import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import backIcon from '../../assets/images/common/back.png'
import { getTheme } from '../../reducers/theme'
import backgroundImage from '../../assets/images/common/background.png'

const containerMargin = '20px'

const styles = () => {
  return {
    wrapper: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: '20vh',
      maxHeight: '20vh',
    },
    background: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0.3,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundImage: `url(${backgroundImage})`,
    },
    container: {
      height: '100%',
      background: 'linear-gradient(-90deg, red, yellow)',
      marginBottom: '-3vh',
      width: '100%',
      position: 'relative',
    },
    header: {
      top: '1vh',
      paddingTop: 'calc(env(safe-area-inset-top) * 0.3)',
      left: containerMargin,
      right: containerMargin,
      position: 'absolute',
    },
    backButton: {
      color: 'white',
      fontSize: '2rem',
      padding: 0,
      background: 'none',
      border: 0,
      outline: 0,
    },
    backButtonIcon: {
      height: '3vh',
    },
    title: {
      color: 'white',
      left: containerMargin,
      position: 'absolute',
      fontSize: '1.7rem',
      fontWeight: '750',
    },
    titleAdjust: {
      color: 'white',
      left: containerMargin,
      bottom: '6vh',
      position: 'absolute',
      fontSize: '2rem',
      fontWeight: '750',
    },
    titleWithChildren: {
      bottom: '6vh',
    },
    titleWithoutChildren: {
      bottom: '3vh',
    },
    childrenContainer: {
      left: containerMargin,
      right: containerMargin,
      position: 'absolute',
      fontSize: '1rem',
      bottom: '2.5vh',
    },
  }
}

const mapStateToProps = (state) => {
  return {
    theme: getTheme(state),
  }
}

@withRouter
@connect(mapStateToProps)
@injectSheet(styles)
class MobileHeader extends Component {
  static defaultProps = {
    adjust: false,
  }

  handleBackButtonClick = () => {
    const { history, backAction } = this.props
    if (typeof backAction === 'function') {
      try {
        backAction()
      } catch (e) {
        history.goBack()
      }
    } else {
      history.goBack()
    }
  }

  render() {
    const {
      classes, title, theme, history, children, adjust,
    } = this.props
    console.log('history: ', history.length, history)
    return (
      <div className={classes.wrapper}>
        <div
          className={classes.container}
          style={{
            background: `linear-gradient(-90deg, ${theme.gradient_color_1}, ${
              theme.gradient_color_2
            })`,
          }}
        >
          <div className={classes.background} />
          <div className={classes.header}>
            {history.length > 1 && title !== 'Wallet' && (
              <button
                type={'button'}
                className={classes.backButton}
                onClick={this.handleBackButtonClick}
              >
                <span className={classes.backButton}>
                  <img src={backIcon} className={classes.backButtonIcon} alt="" />
                </span>
              </button>
            )}
          </div>
          <div
            className={classNames(classes.title, {
              [classes.titleWithChildren]: children && !adjust,
              [classes.titleWithoutChildren]: !children && !adjust,
              [classes.titleAdjust]: adjust,
            })}
          >
            {title}
          </div>
          {children && <div className={classes.childrenContainer}>{children}</div>}
        </div>
      </div>
    )
  }
}

MobileHeader.propTypes = {
  title: PropTypes.string,
  classes: PropTypes.object,
  theme: PropTypes.object,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }),
  children: PropTypes.node,
  adjust: PropTypes.bool,
  backAction: PropTypes.func,
}

export default MobileHeader
